"use client";
import { Modal, Form, Row, Col, Input, Button, message } from "antd";
import { useState } from "react";
import Image from "next/image";
import logo from "@/public/image/logo-nha-nha-khoa-hub.png";
import { LoadingOutlined } from "@ant-design/icons";
import iconCopy from "@/public/icon/icon-copy.png";
import { getCoupon, verifyOTP } from "./get-coupon-service";
import "./get-coupon-modal.scss";

export default function GetCouponModal({
  isModalOpen,
  setIsModalOpen,
  clinic_id,
}) {
  return (
    <Modal
      open={isModalOpen}
      width={803}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      className="get-coupon-modal"
      centered
      destroyOnClose
    >
      <CouponModalBody clinic_id={clinic_id} />
    </Modal>
  );
}

export function CouponModalBody({ clinic_id }) {
  const [form] = Form.useForm();
  const [otpForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [couponCode, setCouponCode] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [submit, setSubmit] = useState(false);

  const handleCouponRequest = async (values) => {
    setLoading(true);
    try {
      const result = await getCoupon({
        ...values,
        clinic_id: clinic_id,
      });
      if (result.status === 400) throw new Error(result.message);
      if (result.data) {
        setCouponCode(result.data.code);
        setSubmit(true);
        setOtpVerified(true);
      } else {
        setSubmit(true);
      }
    } catch (error) {
      message.error(error.message || "Đã xảy ra lỗi.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (values) => {
    setLoading(true);
    try {
      const result = await verifyOTP({ ...values, phoneNumber });
      if (result.status === 400) throw new Error(result.message);
      if (result.data) {
        setCouponCode(result.data.code);
        setOtpVerified(true);
      }
    } catch (error) {
      message.error(error.message || "Đã xảy ra lỗi.");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(couponCode);
    message.success("Mã coupon đã được sao chép.");
  };

  const callNow = () => {
    if (typeof window !== undefined) window.open(`tel:0869554535`, "_self");
  };

  return (
    <div className="wp-coupon-form">
      <Image src={logo} alt="logo" className="logo" />
      <div className="title">SIÊU ƯU ĐÃI - KHUYẾN MÃI HOÀN TIỀN</div>
      {!submit ? (
        <>
          <div className="description">
            Hoàn tiền <span>100.000 VNĐ</span> cho hóa đơn từ 5 - dưới 10 triệu
            <br />
            Hoàn tiền <span>200.000 VNĐ</span> cho hóa đơn từ 10 - dưới 15 triệu
            <br />
            Hoàn tiền <span>300.000 VNĐ</span> cho hóa đơn từ 15 - dưới 30 triệu
            <br />
            Hoàn tiền <span>500.000 VNĐ</span> cho hóa đơn từ 30 - dưới 50 triệu
            <br />
            Hoàn tiền <span>1.000.000 VNĐ</span> cho hóa đơn từ 50 - dưới 100
            triệu
            <br />
            Hoàn tiền <span>1.500.000 VNĐ</span> cho hóa đơn trên 100 triệu
          </div>
          <div className="note">
            Áp dụng cho các nha khoa có gắn nhãn khuyến mãi trên NhaKhoaHub.
            <br />
            (Mã khuyến mãi có hiệu lực trong vòng 30 ngày kể từ ngày đăng ký)
          </div>
          <Form
            form={form}
            className="get-coupon-form"
            onFinish={(values) => {
              setPhoneNumber(values.phone_number);
              handleCouponRequest(values);
            }}
            layout="vertical"
          >
            <Row gutter={[22, 15]}>
              <Col xl={12} md={24} xs={24}>
                <Form.Item
                  name="customer_name"
                  label="Họ và tên:"
                  rules={[
                    { required: true, message: "Vui lòng nhập họ và tên" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xl={12} md={24} xs={24}>
                <Form.Item
                  name="phone_number"
                  label="Số điện thoại nhận mã khuyến mãi qua Zalo: "
                  rules={[
                    { required: true, message: "Vui lòng nhập số điện thoại!" },
                    {
                      validator(_, value) {
                        const phoneNumberRegex = /^0\d{9}$/;
                        if (value && !phoneNumberRegex.test(value)) {
                          return Promise.reject("Số điện thoại không hợp lệ!");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input type="number" inputMode="numeric" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="issue" label="Dịch vụ đăng ký:">
                  <Input.TextArea rows={4} />
                </Form.Item>
              </Col>
              <div className="note-for-form">
                LƯU Ý: Trường được gắn dấu{" "}
                <span style={{ color: "red" }}>*</span> là trường bắt buộc.
              </div>
              <div className="wp-button">
                <Button
                  htmlType="submit"
                  className="button-submit"
                  children={loading ? <LoadingOutlined /> : "ĐĂNG KÝ NGAY"}
                ></Button>
                {!loading && (
                  <Button className="button-submit call-now" onClick={callNow}>
                    {"GỌI NGAY"}
                  </Button>
                )}
              </div>
            </Row>
          </Form>
        </>
      ) : !otpVerified ? (
        <Form
          form={otpForm}
          className="get-coupon-form"
          onFinish={handleOtpSubmit}
          layout="vertical"
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="otp"
                className="otp-input"
                label="Vui lòng nhập mã OTP đã được gửi đến Zalo của bạn:"
                rules={[{ required: true, message: "Vui lòng nhập mã OTP!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <div className="wp-button">
              <Button htmlType="submit" className="button-submit">
                {loading ? <LoadingOutlined /> : "HOÀN TẤT ĐĂNG KÝ"}
              </Button>
            </div>
          </Row>
        </Form>
      ) : (
        <>
          <div className="success-title">Bạn đã đăng ký thành công!</div>
          <div className="wp-code">
            Mã khuyến mại của bạn là:&nbsp;&nbsp;
            <div className="code-and-copy">
              <div className="code">{couponCode}</div>&nbsp;&nbsp;
              <Image
                className="icon-copy"
                src={iconCopy}
                alt="icon"
                width={18}
                style={{ cursor: "pointer" }}
                onClick={copyToClipboard}
              />
            </div>
          </div>
          <div className="coupon-guide">
            <div className="title title-guide">
              HƯỚNG DẪN SỬ DỤNG MÃ KHUYẾN MÃI
            </div>
            <span className="detail-guide">
              <span style={{ display: "flex" }}>
                <b style={{ textWrap: "nowrap" }}>Bước 1:&nbsp;</b>
                <span style={{ display: "block" }}>
                  Đặt lịch và đến sử dụng dịch vụ tại nha khoa.
                </span>
              </span>
              <div></div>
              <span style={{ display: "flex" }}>
                <b style={{ textWrap: "nowrap" }}>Bước 2:&nbsp;</b>
                <span style={{ display: "block" }}>
                  Chụp lại hóa đơn và cung cấp mã khuyến mãi cho NhaKhoaHub để
                  được hoàn tiền theo giá trị tương ứng.
                </span>
              </span>
              <div></div>
              <span style={{ display: "flex" }}>
                <b style={{ textWrap: "nowrap" }}>LƯU Ý:&nbsp;</b>
                <span style={{ display: "block" }}>
                  <b>
                    Đối với các dịch vụ nha khoa trả góp, NhaKhoaHub sẽ hoàn
                    tiền lại theo 2 lần:
                  </b>
                </span>
              </span>
              <div></div>
              <span>
                - Lần 1: NhaKhoaHub hoàn lại 50% trên tổng giá trị khuyến mãi
                tương ứng với dịch vụ đăng kí của khách hàng tại nha khoa trong
                vòng 15 ngày sau khi khách hàng sử dụng dịch vụ tại nha khoa.
              </span>
              <div></div>
              <span>
                - Lần 2: NhaKhoaHub hoàn lại 50% giá trị khuyến mãi còn lại
                trong vòng 45 ngày sau khi khách hàng sử dụng dịch vụ tại nha
                khoa.
              </span>
            </span>
            <div className="description coupon-guide-description">
              Hoàn tiền <span>100.000 VNĐ</span> cho hóa đơn từ 5 - dưới 10
              triệu
              <br />
              Hoàn tiền <span>200.000 VNĐ</span> cho hóa đơn từ 10 - dưới 15
              triệu
              <br />
              Hoàn tiền <span>300.000 VNĐ</span> cho hóa đơn từ 15 - dưới 30
              triệu
              <br />
              Hoàn tiền <span>500.000 VNĐ</span> cho hóa đơn từ 30 - dưới 50
              triệu
              <br />
              Hoàn tiền <span>1.000.000 VNĐ</span> cho hóa đơn từ 50 - dưới 100
              triệu
              <br />
              Hoàn tiền <span>1.500.000 VNĐ</span> cho hóa đơn trên 100 triệu
            </div>
            <div className="note">
              (Mã khuyến mãi có hiệu lực trong vòng 30 ngày kể từ ngày đăng ký)
            </div>
          </div>
          <Button className="button-submit nkh-call-now" onClick={callNow}>
            {"LIÊN HỆ NHAKHOAHUB"}
          </Button>
        </>
      )}
    </div>
  );
}
